import { Box } from '@mui/material'
import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { SelectChangeEvent } from '@mui/material'
import CustomInput from '../../../../components/muiComponents/customInput'
import SingleSelect from '../../../../components/muiComponents/singleSelect/SingleSelect'
import { H6 } from '../../../../layouts/TextStyles'
import { teacherApiSlice } from '../../../../features/teacher/teacherSlice'
import { capitalize } from '../../../../utils/functions'
import { GroupSubjectState } from '../../../../features/types'

const SelectedSubject = ({
    formik,
    courseSubjectId,
    index,
    courseSubjects,
}) => {
    const { formatMessage, locale } = useIntl()
    const { teachers } = teacherApiSlice.useFetchAllTeachersQuery(
        {
            query: `page=${0}&size=${10000}`,
            roles: ['TEACHER'],
        },
        {
            selectFromResult: ({ data }) => ({
                teachers: data?.data,
            }),
        },
    )

    const groupSubject: GroupSubjectState = {
        teacherId: '',
        lessonLink: '',
        lessonComment: '',
        courseSubjectId: courseSubjectId,
    }

    const handleTeacherChange = (event: SelectChangeEvent) => {
        const {
            target: { value },
        } = event

        formik.setFieldValue(
            `subjects[${index}].teacherId`,
            typeof value === 'string' ? value.split(',') : value,
        )
    }

    const getCourseSubjectName = () => {
        return courseSubjects.find(
            (courseSubject) => courseSubject.id === courseSubjectId,
        )[`title${capitalize(locale)}`]
    }

    useEffect(() => {
        if (courseSubjectId) {
            formik.setFieldValue('subjects', [
                ...formik.values.subjects,
                groupSubject,
            ])
        }

        return function () {
            const filteredSubjects = formik.values.subjects.filter(
                (item) => item.courseSubjectId !== courseSubjectId,
            )

            formik.setFieldValue('subjects', filteredSubjects)
        }
    }, [])

    return (
        <Box mb={2}>
            <H6>{getCourseSubjectName()}</H6>
            <CustomInput
                name={`subjects[${index}].lessonLink`}
                placeholder={formatMessage({ id: 'link' })}
                fullWidth
                value={formik.values?.subjects[index]?.lessonLink}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                margin="dense"
            />

            <SingleSelect
                name={`subjects[${index}].teacherId`}
                placeholder={formatMessage({
                    id: 'teacher',
                })}
                value={formik.values?.subjects[index]?.teacherId}
                handleChange={handleTeacherChange}
                menuItems={teachers}
            />

            <CustomInput
                name={`subjects[${index}].lessonComment`}
                placeholder={formatMessage({
                    id: 'comment',
                })}
                fullWidth
                value={formik.values?.subjects[index]?.lessonComment}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                margin="dense"
            />
        </Box>
    )
}

export default SelectedSubject
